/* VKQuickOptionsV2: single authoritative accessible in-card variant selector */
(function () {
  if (window.VKQuickOptionsV2) return;
  window.VKQuickOptionsV2 = true;

  var activeTrigger = null;
  var productData = null;
  var selectedVariant = null;

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  function announce(message) {
    var region = document.querySelector('[data-vk-commerce-live]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'visually-hidden';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('data-vk-commerce-live', '');
      document.body.appendChild(region);
    }
    region.textContent = message;
  }

  function ensureDialog() {
    var dialog = document.getElementById('vk-quick-options');
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.id = 'vk-quick-options';
    dialog.className = 'vk-quick-options';
    dialog.hidden = true;
    dialog.innerHTML =
      '<div class="vk-quick-options__backdrop" data-vk-quick-close></div>' +
      '<section class="vk-quick-options__panel" role="dialog" aria-modal="true" aria-labelledby="vk-quick-options-title">' +
        '<button type="button" class="vk-quick-options__close" aria-label="Close option selector" data-vk-quick-close>×</button>' +
        '<p class="vk-quick-options__eyebrow">SELECT YOUR PRODUCT</p>' +
        '<div class="vk-quick-options__summary">' +
          '<img class="vk-quick-options__image" alt="" data-vk-quick-image>' +
          '<div><h2 id="vk-quick-options-title" data-vk-quick-title></h2><p class="vk-quick-options__price" data-vk-quick-price></p></div>' +
        '</div>' +
        '<div class="vk-quick-options__fields" data-vk-quick-fields></div>' +
        '<p class="vk-quick-options__status" data-vk-quick-status aria-live="polite"></p>' +
        '<button type="button" class="vk-quick-options__submit" data-vk-quick-submit>Add selected product to cart</button>' +
        '<a class="vk-quick-options__details" data-vk-quick-details>View full product details →</a>' +
      '</section>';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (event) {
      if (event.target.closest('[data-vk-quick-close]')) closeDialog();
    });
    dialog.querySelector('[data-vk-quick-submit]').addEventListener('click', addSelected);
    return dialog;
  }

  function closeDialog() {
    var dialog = document.getElementById('vk-quick-options');
    if (!dialog || dialog.hidden) return;
    dialog.hidden = true;
    document.documentElement.classList.remove('vk-quick-options-open');
    if (activeTrigger) activeTrigger.focus();
  }

  function updateSelection() {
    var dialog = ensureDialog();
    var values = Array.from(dialog.querySelectorAll('[data-vk-quick-select]')).map(function (select) { return select.value; });
    selectedVariant = productData.variants.find(function (variant) {
      return variant.options.every(function (value, index) { return value === values[index]; });
    }) || null;
    var submit = dialog.querySelector('[data-vk-quick-submit]');
    var status = dialog.querySelector('[data-vk-quick-status]');
    if (!selectedVariant) {
      submit.disabled = true;
      status.textContent = 'This combination is not available.';
      return;
    }
    dialog.querySelector('[data-vk-quick-price]').textContent = money(selectedVariant.price);
    submit.disabled = !selectedVariant.available;
    submit.textContent = selectedVariant.available ? 'Add selected product to cart' : 'Currently unavailable';
    status.textContent = selectedVariant.available ? 'Ready to add' : 'Please choose another available combination.';
  }

  function renderProduct(data, productUrl) {
    productData = data;
    var dialog = ensureDialog();
    dialog.querySelector('[data-vk-quick-title]').textContent = data.title;
    dialog.querySelector('[data-vk-quick-details]').href = productUrl;
    var image = dialog.querySelector('[data-vk-quick-image]');
    if (data.featured_image) {
      image.src = data.featured_image;
      image.alt = data.title;
      image.hidden = false;
    } else image.hidden = true;
    var firstAvailable = data.variants.find(function (variant) { return variant.available; }) || data.variants[0];
    var fields = dialog.querySelector('[data-vk-quick-fields]');
    fields.innerHTML = '';
    (data.options || []).forEach(function (option, index) {
      var label = document.createElement('label');
      label.className = 'vk-quick-options__field';
      var caption = document.createElement('span');
      caption.textContent = option.name;
      var select = document.createElement('select');
      select.setAttribute('data-vk-quick-select', '');
      select.setAttribute('aria-label', option.name);
      option.values.forEach(function (value) {
        var item = document.createElement('option');
        item.value = value;
        item.textContent = value;
        if (firstAvailable && firstAvailable.options[index] === value) item.selected = true;
        select.appendChild(item);
      });
      select.addEventListener('change', updateSelection);
      label.appendChild(caption);
      label.appendChild(select);
      fields.appendChild(label);
    });
    updateSelection();
    dialog.hidden = false;
    document.documentElement.classList.add('vk-quick-options-open');
    dialog.querySelector('.vk-quick-options__close').focus();
  }

  function openFor(trigger) {
    activeTrigger = trigger;
    var productUrl = new URL(trigger.href, window.location.origin);
    var jsonUrl = productUrl.pathname.replace(/\/$/, '') + '.js';
    trigger.classList.add('is-loading');
    var label = trigger.querySelector('span');
    var original = label ? label.textContent : 'Choose options';
    if (label) label.textContent = 'Loading…';
    fetch(jsonUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
      .then(function (data) { renderProduct(data, productUrl.pathname); })
      .catch(function () { announce('Options could not be loaded. Opening product details.'); window.location.href = productUrl.href; })
      .finally(function () { trigger.classList.remove('is-loading'); if (label) label.textContent = original; });
  }

  function addSelected() {
    if (!selectedVariant || !selectedVariant.available) return;
    var dialog = ensureDialog();
    var submit = dialog.querySelector('[data-vk-quick-submit]');
    submit.disabled = true;
    submit.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: selectedVariant.id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { if (!response.ok) throw new Error('Cart request failed'); return response.json(); })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (state.sections) {
          var bubble = document.querySelector('#cart-icon-bubble');
          var bubbleHTML = state.sections['cart-icon-bubble'];
          if (bubble && bubbleHTML) {
            var bubbleDocument = new DOMParser().parseFromString(bubbleHTML, 'text/html');
            var freshBubble = bubbleDocument.querySelector('#shopify-section-cart-icon-bubble');
            if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
          }
          var drawerHTML = state.sections['cart-drawer'];
          if (drawer && drawerHTML) {
            var drawerDocument = new DOMParser().parseFromString(drawerHTML, 'text/html');
            var freshDrawer = drawerDocument.querySelector('#CartDrawer');
            var currentDrawer = drawer.querySelector('#CartDrawer');
            if (freshDrawer && currentDrawer) currentDrawer.innerHTML = freshDrawer.innerHTML;
            drawer.classList.remove('is-empty');
            if (typeof drawer.open === 'function') drawer.open();
            else {
              drawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          }
        }
        announce('Selected product added to cart');
        document.dispatchEvent(new CustomEvent('vk:cart-updated'));
        submit.textContent = 'Added to cart ✓';
        setTimeout(closeDialog, 650);
      })
      .catch(function () {
        submit.disabled = false;
        submit.textContent = 'Try adding again';
        dialog.querySelector('[data-vk-quick-status]').textContent = 'Could not add this option. Please try again.';
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.vk-commerce-card__actions a.vk-commerce-card__add');
    if (!trigger || !/choose options/i.test(trigger.textContent)) return;
    event.preventDefault();
    openFor(trigger);
  });
  document.addEventListener('keydown', function (event) {
    var dialog = document.getElementById('vk-quick-options');
    if (!dialog || dialog.hidden) return;
    if (event.key === 'Escape') closeDialog();
    if (event.key === 'Tab') {
      var focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), select, a[href]'));
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
})();
